/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { NgModule, ModuleWithProviders } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpRequest } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  NbAuthJWTInterceptor,
  NbAuthModule,
  NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
  NbTokenLocalStorage
} from '@nebular/auth';
import { AuthInterceptor } from './auth.interceptor';
import { AuthGuard } from './auth.guard';
import { AdminGuard } from './admin.guard';
import { AuthPipe } from './auth.pipe';
import { RoleProvider } from './role.provider';
import { NbRoleProvider, NbSecurityModule } from '@nebular/security';

import {
  NgxLoginComponent,
  NgxAuthComponent,
  NgxAuthBlockComponent,
  NgxLogoutComponent,
  NgxRegisterComponent,
  NgxRequestPasswordComponent,
  NgxResetPasswordComponent,
  NgxVerifyComponent
} from './components';

import {
  NbAlertModule,
  NbCardModule,
  NbIconModule,
  NbLayoutModule,
  NbCheckboxModule,
  NbInputModule,
  NbButtonModule
} from '@nebular/theme';
import { AuthRoutingModule } from './auth-routing.module';
import { ComponentsModule } from '../@components/components.module';
import { authOptions } from './auth.settings';
import { authSettings } from './access.settings';
import { environment } from 'environments/environment';

const GUARDS = [AuthGuard, AdminGuard];
const PIPES = [AuthPipe];
const COMPONENTS = [
  NgxLoginComponent,
  NgxAuthComponent,
  NgxLogoutComponent,
  NgxRegisterComponent,
  NgxRequestPasswordComponent,
  NgxResetPasswordComponent,
  NgxAuthBlockComponent,
  NgxVerifyComponent
];

const NB_MODULES = [
  NbIconModule,
  NbLayoutModule,
  NbCardModule,
  NbAlertModule,
  NbCheckboxModule,
  NbInputModule,
  NbButtonModule
];

export function filterInterceptorRequest(req: HttpRequest<any>): boolean {
  // filtered requests are ones where the interceptor will be ignored
  try {
    let filterIncludes = false;
    const includesURL = ['/auth/login',
      '/auth/sign-up',
      '/auth/request-pass',
      '/auth/refresh-token',]

    filterIncludes = includesURL.some((url) => req.url.includes(url));

    let filterExplicit = false;
    // config are only gets
    if (req.method === 'GET') {
      const apiUrl = environment.apiUrl;

      // list requests which don't require auth and called as part of the app initialisation otherwise refresh tokens will try to be created and all fail spectacularly 
      const explicityOnlyURL = []
      
      if (explicityOnlyURL.includes(req.url)) filterExplicit = true;
    }

    let overallResult = false;
    if (filterExplicit || filterIncludes) overallResult = true;

    return overallResult;
  } catch (error) {
    // console.log(error); //sometimes req is not defined, not sure why, but return false
    return false;
  }
}

@NgModule({
  declarations: [...PIPES, ...COMPONENTS],
  imports: [
    AuthRoutingModule,
    ReactiveFormsModule,
    CommonModule,
    ComponentsModule,
    ...NB_MODULES,
    NbAuthModule.forRoot(authOptions)
  ],
  exports: [...PIPES],
  providers: [
    NbSecurityModule.forRoot({
      accessControl: authSettings
    }).providers,
    {
      provide: NbRoleProvider,
      useClass: RoleProvider
    },
    {
      provide: NbTokenLocalStorage,
      useClass: NbTokenLocalStorage
    }
  ]
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        {
          provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
          useValue: filterInterceptorRequest
        },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        ...GUARDS
      ]
    };
  }
}
